module.exports = __webpack_public_path__ + "static/media/notification.c8e4cd20.mp3";